import {
  LockClosedIcon,
  ArchiveBoxIcon,
  BoltIcon,
} from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom';

const secondaryFeatures = [
  {
    name: 'Information from Real Cases',
    description:
      'TeaPot uses real case law to provide you with legal advice that is relevant to your local laws. We provide you with the most relevant information to help you make the best decision for your case.',
    icon: ArchiveBoxIcon,
  },
  {
    name: 'Privacy & Security',
    description:
      'Privacy and security are our top priorities. We do not store any user information to help you stay anonymous.',
    icon: LockClosedIcon,
  },
  {
    name: 'Powered by AI',
    description:
      'TeaPot uses the latest AI technology to provide you with the best legal advice based on your situation.',
    icon: BoltIcon,
  },
]

export default function Example() {

  return (
    <div className="bg-white">

    {/* Header */}
    <header className="flex items-center justify-center p-4 bg-gradient-to-r from-[#AF40FF] via-[#5B42F3] to-[#00DDEB] text-white font-semibold text-lg">
      <div className="flex items-center">
        <Link to="/">
          <img src="/teaPot.png" alt="Logo" className="w-10 h-10 mr-2" />
        </Link>
        <span>TeaPot - Democratization of Law Information</span>
      </div>
    </header>

      <main>
        {/* Hero section */}
        <div className="relative isolate ">

          <div className="mx-auto max-w-7xl px-6 py-5 sm:py-32 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">

              <h1 className="mt-10 text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                Legal Advice Backed by AI & Real Cases
              </h1>
              <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                Teapot's AI-powered legal advice platform provides you with the best legal advice based on real case law from your local area.
              </p>
              <div className="mt-10 flex items-center gap-x-6">
                <Link
                  to="/chat"
                  className="rounded-md bg-gradient-to-r from-[#AF40FF] via-[#5B42F3] to-[#00DDEB] px-5 py-2.5 text-2xl font-semibold text-white shadow-sm hover:from-blue-500 hover:to-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                >
                  Get started ➡
                </Link>
              </div>
            </div>
            <div className="mt-16 py-5 sm:mt-24 lg:mt-0 lg:shrink-0 lg:grow">
              <svg role="img" viewBox="0 0 366 729" className="mx-auto w-[22.875rem] max-w-full drop-shadow-xl">
                <title>App screenshot</title>
                <defs>
                  <clipPath id="2ade4387-9c63-4fc4-b754-10e687a0d332">
                    <rect rx={36} width={316} height={684} />
                  </clipPath>
                </defs>
                <path
                  d="M363.315 64.213C363.315 22.99 341.312 1 300.092 1H66.751C25.53 1 3.528 22.99 3.528 64.213v44.68l-.857.143A2 2 0 0 0 1 111.009v24.611a2 2 0 0 0 1.671 1.973l.95.158a2.26 2.26 0 0 1-.093.236v26.173c.212.1.398.296.541.643l-1.398.233A2 2 0 0 0 1 167.009v47.611a2 2 0 0 0 1.671 1.973l1.368.228c-.139.319-.314.533-.511.653v16.637c.221.104.414.313.56.689l-1.417.236A2 2 0 0 0 1 237.009v47.611a2 2 0 0 0 1.671 1.973l1.347.225c-.135.294-.302.493-.49.607v377.681c0 41.213 22 63.208 63.223 63.208h95.074c.947-.504 2.717-.843 4.745-.843l.141.001h.194l.086-.001 33.704.005c1.849.043 3.442.37 4.323.838h95.074c41.222 0 63.223-21.999 63.223-63.212v-394.63c-.259-.275-.48-.796-.63-1.47l-.011-.133 1.655-.276A2 2 0 0 0 366 266.62v-77.611a2 2 0 0 0-1.671-1.973l-1.712-.285c.148-.839.396-1.491.698-1.811V64.213Z"
                  fill="#4B5563"
                />
                <path
                  d="M16 59c0-23.748 19.252-43 43-43h246c23.748 0 43 19.252 43 43v615c0 23.196-18.804 42-42 42H58c-23.196 0-42-18.804-42-42V59Z"
                  fill="#343E4E"
                />
                <foreignObject
                  width={316}
                  height={684}
                  clipPath="url(#2ade4387-9c63-4fc4-b754-10e687a0d332)"
                  transform="translate(24 24)"
                >
                  <img alt="" src="/Screenshot_chat.png" />
                </foreignObject>
              </svg>
            </div>
          </div>
        </div>

        {/* Logo cloud */}
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:grid-cols-5">
            <img
              alt="Tailwind"
              src="/Tailwind_CSS_logo.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
            <img
              alt="OpenAI"
              src="openai-logo.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
            <img
              alt="JavaScript"
              src="javascript.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
            <img
              alt="React"
              src="logo512.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
            />
            <img
              alt="Google Cloud"
              src="gcloud.png"
              width={158}
              height={48}
              className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
            />
          </div>
        </div>



        {/* Feature section */}
        <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8">
          <div className="mx-auto max-w-2xl lg:text-center">
            <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance">
            Justice Enhanced by AI. Clarity Empowered by Case Law
            </p>
            <p className="mt-6 text-lg/8 text-gray-600">
            TeaPot uses AI and case law to provide clear, reliable legal advice. We make complex legal issues easier to understand, 
            giving you straightforward guidance you can trust.
            </p>
          </div>
          <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
              {secondaryFeatures.map((feature) => (
                <div key={feature.name} className="flex flex-col">
                  <dt className="flex items-center gap-x-3 text-base/7 font-semibold text-gray-900">
                    <feature.icon aria-hidden="true" className="h-5 w-5 flex-none text-indigo-600" />
                    {feature.name}
                  </dt>
                  <dd className="mt-4 flex flex-auto flex-col text-base/7 text-gray-600">
                    <p className="flex-auto">{feature.description}</p>
  
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </main>

    {/* Footer */}
    <footer className="mt-32 bg-gray-900 sm:mt-56">
    <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-center lg:px-8">
        <p className="text-center text-sm/6 text-gray-600 md:order-first">
        &copy; 2024 TeaPot, Inc. All rights reserved.
        </p>
    </div>
    </footer>

    </div>
  )
}
